<template>
    <div>
        <div class="p-4" :class="{'bottom-line': ! billingError }">
            <p v-if="billingError" class="text-danger mb-4 font-medium leading-snug text-center">
                There’s been an issue with your billing account.<br />
                Please update now.
            </p>
            <div v-if="account" class="flex justify-between items-center">
                <p>
                    Account
                </p>
                <p class="font-semibold">{{ account.name || account.official_name }}</p>
            </div>
        </div>
        <div v-if="account && account.subtype" class="p-4 flex justify-between items-center bottom-line">
            <p>
                Account Type
            </p>
            <p class="font-semibold">
                {{ formatSubType(account.subtype) }} ({{ account.mask }})
            </p>
        </div>
        <div v-if="account" class="p-4 flex justify-between items-center bottom-line">
            <p>
                Account Number
                <a @click.prevent="changeBank" class="cursor-pointer font-semibold no-underline text-sm ml-2">
                    Update
                </a>
            </p>
            <p class="font-semibold flex items-center">
                <template>
                    {{ account.manual_account_number_last_four ? '******'+account.manual_account_number_last_four : account.mask }}
                </template>
            </p>
        </div>
        <div v-if="account" class="p-4 flex justify-between items-center bottom-line">
            <p>
                Routing Number
                <a @click.prevent="changeBank" class="cursor-pointer font-semibold no-underline text-sm ml-2">
                    Update
                </a>
            </p>
            <p class="font-semibold">
                <template>
                    {{ '******'+(account.manual_routing_number_last_four || account.routing_number_last_four || '') }}
                </template>
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['account', 'billing-error'],

        data() {
            return {
                editingManual: false,
                loadingManual: false,
                manual_account_number: null,
                manual_routing_number: null
            }
        },

        mounted() {
            this.manual_account_number = this.account?.manual_account_number;
            this.manual_routing_number = this.account?.manual_routing_number;
        },

        methods: {
            changeBank() {
                window.location.href = `/account/change-bank`;
            },
            updateManual() {
                this.loadingManual = true;

                this.$http.post(`/account/manual`, {
                    manual_routing_number: this.manual_routing_number,
                    manual_account_number: this.manual_account_number,
                    banking_account_id: this.account.id
                }).then(({ data }) => {
                    this.editingManual = false;
                    this.loadingManual = false;

                    if (this.account?.manual_account_number !== this.manual_account_number) {
                        this.$root.$emit('action', 'changed-manual-account_number');
                    }

                    this.$root.$emit('updateUser', data);
                });
            },

            /**
             * @param {String} subType
             * @returns {String}
             */
            formatSubType(subType) {
                switch (subType) {
                    case 'cd':
                        return 'CD';
                    default:
                        return this.$options.filters.ucfirst(subType);
                }
            }
        }
    }
</script>
